// ORDRE&GO — sélecteur d'offre + galerie
(function () {
  function euro(n) {
    return n.toFixed(2).replace('.', ',') + ' €';
  }

  function init() {
    var root = document.querySelector('[data-og-root]');
    if (!root) return;

    var main = root.querySelector('[data-og-main]');
    var thumbs = root.querySelectorAll('[data-og-thumb]');
    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        thumbs.forEach(function (b) { b.setAttribute('aria-current', 'false'); });
        btn.setAttribute('aria-current', 'true');
        if (main) {
          main.src = btn.getAttribute('data-src');
          main.alt = btn.getAttribute('data-alt') || '';
        }
      });
    });

    var offers = root.querySelectorAll('[data-og-offer]');
    var priceEls = root.querySelectorAll('[data-og-price]');
    var strikeEls = root.querySelectorAll('[data-og-strike]');
    var unitEls = root.querySelectorAll('[data-og-unit]');
    var labelEls = root.querySelectorAll('[data-og-label]');
    var ctaEls = root.querySelectorAll('[data-og-cta]');
    var base = root.getAttribute('data-cart-base');

    function select(btn) {
      offers.forEach(function (o) {
        o.setAttribute('aria-pressed', o === btn ? 'true' : 'false');
        var badge = o.querySelector('[data-og-badge]');
        if (badge) badge.textContent = o === btn ? 'Sélectionné' : badge.getAttribute('data-default');
      });

      var price = parseFloat(btn.getAttribute('data-price'));
      var strike = btn.getAttribute('data-strike');
      var unit = parseFloat(btn.getAttribute('data-perunit'));
      var qty = btn.getAttribute('data-qty');
      var label = btn.getAttribute('data-label');

      priceEls.forEach(function (el) { el.textContent = euro(price); });
      unitEls.forEach(function (el) { el.textContent = euro(unit) + ' / oreiller'; });
      labelEls.forEach(function (el) { el.textContent = label; });
      strikeEls.forEach(function (el) {
        if (strike) { el.textContent = euro(parseFloat(strike)); el.style.display = ''; }
        else { el.textContent = ''; el.style.display = 'none'; }
      });
      ctaEls.forEach(function (el) {
        el.setAttribute('href', base + ':' + qty);
        var t = el.querySelector('[data-og-cta-text]');
        if (t) t.textContent = t.getAttribute('data-prefix') + ' · ' + euro(price);
      });
    }

    offers.forEach(function (btn) {
      btn.addEventListener('click', function () { select(btn); });
    });

    var def = root.querySelector('[data-og-offer][data-default-offer="true"]') || offers[0];
    if (def) select(def);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
